module.exports = __webpack_public_path__ + "img/sex_man_active.4a3ef236.png";